import { z } from 'zod/v3';

import type { UpdateShippingAddressRequest } from './schemas';
import { updateShippingAddressRequestSchema } from './schemas';

/**
 * 배송지 수정 폼 데이터 스키마
 * @description react-hook-form의 defaultValues로 사용하기 위해 빈 값을 허용하는 폼 전용 스키마
 * @see PUT /api/market-place/v1/shipping-address
 */
export const addressUpdateFormDataSchema = z.object({
  /** 배송지 ID */
  shippingAddressId: z.number(),
  /** 상호명 (필수) */
  businessName: z.string(),
  /** 수령자 (필수) */
  recipient: z.string(),
  /** 수령자 전화번호 (필수) */
  recipientPhoneNumber: z.string(),
  /** 우편번호(zonecode, 필수) */
  zipCode: z.string(),
  /** 주소지 (필수) */
  address: z.string(),
  /** 상세주소지 (선택) */
  detailAddress: z.string(),
  /** 법정동 코드(bcode, 필수) */
  regionCode: z.string(),
  /** 배송 요청 사항 (선택) */
  requestForDelivery: z.string().optional(),
});
export type AddressUpdateFormData = z.infer<typeof addressUpdateFormDataSchema>;

/**
 * AddressUpdateFormData를 API 요청 형식으로 변환
 */
export function toUpdateShippingAddressRequest(
  formData: AddressUpdateFormData,
): UpdateShippingAddressRequest {
  return updateShippingAddressRequestSchema.parse({
    shippingAddressId: formData.shippingAddressId,
    address: formData.address,
    businessName: formData.businessName || undefined,
    detailAddress: formData.detailAddress || undefined,
    recipient: formData.recipient,
    recipientPhoneNumber: formData.recipientPhoneNumber,
    regionCode: formData.regionCode,
    requestForDelivery: formData.requestForDelivery,
    zipCode: formData.zipCode,
  });
}
